import React from 'react';
import './Metrics.css';

const workData = [
  {
    id: '01',
    type: 'BUILDING',
    title: 'Keruvva',
    description:
      'A participation infrastructure platform exploring how AI, digital twins and spatial computing can connect people with real-world action.',
    link: 'keruvva.com',
    linkText: 'EXPLORE KERUVVA ↗'
  },
  {
    id: '02',
    type: 'RESEARCHING',
    title: 'Technology, People & Systems',
    description:
      'Research and essays exploring technology, human behaviour, responsibility and the systems that shape how we live.',
    link: '',
    linkText: 'READ THE IDEAS ↗'
  },
  {
    id: '03',
    type: 'WRITING',
    title: 'Fiction & Literature',
    description:
      'Stories in progress spanning fiction, Christian literature and reflective writing.',
    link: '/writing',
    linkText: 'ENTER THE WRITING ROOM ↗'
  },
  {
    id: '04',
    type: 'EXPLORING',
    title: 'Questions Worth Asking',
    description:
      'I am interested in difficult questions about identity, family, responsibility, faith, technology and what we pass on to one another.',
    link: '/writing',
    linkText: 'FOLLOW THE THINKING ↗'
  }
];

const Metrics = () => {
  return (
    <section className="metrics-section work-index-section">

      <div className="container">

        <div className="work-index-header">
          <span className="work-index-eyebrow">
            CURRENTLY
          </span>

          <h2>
            A few things
            <br />
            <i>taking shape.</i>
          </h2>

          <p>
            Not everything I work on becomes a company.
            Some ideas become research. Some become stories.
            Some are simply questions I am not finished asking.
          </p>
        </div>

        <div className="work-index-grid">

          {workData.map((work) => (
            <article
              key={work.id}
              className="work-index-card"
            >

              <div className="work-index-top">
                <span className="work-index-number">
                  {work.id}
                </span>

                <span className="work-index-type">
                  {work.type}
                </span>
              </div>

              <h3>
                {work.title}
              </h3>

              <p>
                {work.description}
              </p>

              <a href={work.link}>
                {work.linkText}
              </a>

            </article>
          ))}

        </div>

        <div className="work-index-note">
          <i>
            Some are public. Some are still being written.
            All are part of the work.
          </i>
        </div>

      </div>

    </section>
  );
};

export default Metrics;
